import moment, {Moment} from 'moment-timezone'
import {useCallback} from 'react'

import {useUpmPlantTimezone} from './useUpmPlantTimezone'

/**
 * Hook that returns a function to get the current moment in the plant's timezone.
 *
 * @overload Zero-param — reads timezone from UpmPlantProvider context
 * @overload With `plantUpmId` — explicit lookup by UPM ID
 * @overload With `plantId` string — deprecated legacy lookup
 */
export function useUpmPlantNow(): () => Moment
export function useUpmPlantNow(params: {plantUpmId: string}): () => Moment
/** @deprecated Use `useUpmPlantNow({plantUpmId})` or zero-param context version instead. */
export function useUpmPlantNow(plantId: string): () => Moment
export function useUpmPlantNow(paramsOrPlantId?: string | {plantUpmId: string}): () => Moment {
  const timezone = useUpmPlantTimezone(paramsOrPlantId as Parameters<typeof useUpmPlantTimezone>[0])
  return useCallback(() => moment().tz(timezone), [timezone])
}
